import React, { useState } from 'react'

const maskId = str => {
    if (!str) return ''
    if (str.length === 18) {
        return str.replace(/^(.{6})(.*?)(.{4})$/, '$1********$3')
    }
    if (str.length > 8) {
        return str.slice(0, 4) + '***' + str.slice(-4)
    }
    return str
}

export function PassengerInfo(props) {
    const { passengers } = props
    const [expanded, setExpanded] = useState(false)

    if (!passengers || passengers.length === 0) return null

    const displayList = expanded ? passengers : [passengers[0]]

    return (
        <div className="passenger-info-wrap invoice-details" style={{ marginTop: 16, borderTop: '1px dashed #e6e6e6', paddingTop: 16 }}>
            <div className="invoice-details-thead" style={{ display: 'flex', margin: '0 0 8px', color: '#d37b45' }}>
                <div style={{ flex: 1 }}>{i18n.get('出行人')}</div>
                <div style={{ width: 150 }}>{i18n.get('身份证件号码')}</div>
                <div style={{ width: 100 }}>{i18n.get('出发地')}</div>
                <div style={{ width: 100 }}>{i18n.get('到达地')}</div>
                <div style={{ width: 60 }}>{i18n.get('等级')}</div>
                <div style={{ width: 80 }}>{i18n.get('交通工具类型')}</div>
            </div>
            <div className="invoice-details-tbody">
                {displayList.map((item, idx) => {
                    if (!item) return null
                    return (
                        <div key={idx} style={{ display: 'flex', marginBottom: 4, alignItems: 'center' }}>
                            <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item['E_system_发票主体_出行人']}>
                                {item['E_system_发票主体_出行人'] || '--'}
                            </div>
                            <div style={{ width: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={maskId(item['E_system_发票主体_身份证件号码'])}>
                                {maskId(item['E_system_发票主体_身份证件号码']) || '--'}
                            </div>
                            <div style={{ width: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item['E_system_发票主体_出发地']}>
                                {item['E_system_发票主体_出发地'] || '--'}
                            </div>
                            <div style={{ width: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item['E_system_发票主体_到达地']}>
                                {item['E_system_发票主体_到达地'] || '--'}
                            </div>
                            <div style={{ width: 60, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item['E_system_发票主体_座位等级']}>
                                {item['E_system_发票主体_座位等级'] || '--'}
                            </div>
                            <div style={{ width: 80, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item['E_system_发票主体_交通工具类型']}>
                                {item['E_system_发票主体_交通工具类型'] || '--'}
                            </div>
                        </div>
                    )
                })}
            </div>
            {passengers.length > 1 && (
                <div
                    style={{ width: '100%', height: 26, lineHeight: '26px', textAlign: 'center', color: '#595959', marginTop: 12, cursor: 'pointer', backgroundColor: '#ffffff', border: 'solid 1px #e8e8e8' }}
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? i18n.get('收起旅客明细') : i18n.get('查看完整旅客明细')}
                </div>
            )}
        </div>
    )
}
